import { now } from "jquery";
import React from "react";
import { CustomerType } from "../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { CustomerStatus } from "../../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { RoleType } from "../../../../../../Wrap/Constants/Enums/RoleType";
import { AccountStatus } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { CoachMarkerSetType } from "../../../../../../Wrap/Models/Models/CoachMarkers/CoachMarkerSetType";
import { CoachMarkerStepPosition } from "../../../../../Shared/CoachMarkers/CoachMarker";
import { ICoachMarkerPageConfig } from "../../../../../Shared/CoachMarkers/CoachMarkerContext";

export const enum clientTypeEnum {
    Individual = "Individual",
    Organisation = "Organisation",
    Consolidated = "Consolidated",
    AdvancedSerach = "AdvancedSearch",
}

export const customerStatusMap = {
    [CustomerStatus.NotSpecified]: "All",
    [CustomerStatus.Inactive]: "Inactive",
    [CustomerStatus.Active]: "Active",
    [CustomerStatus.Deceased]: "Deceased",
};

export const individualClientStatus =
{
    [CustomerStatus.NotSpecified]: "All",
    [CustomerStatus.Active]: "Active",
    [CustomerStatus.Prospect]: "Prospect",
    [CustomerStatus.Deceased]: "Deceased",
};

export const organisationTypeArray = [
    CustomerType.NotSpecified,
    CustomerType.Trust,
    CustomerType.CorporateTrust,
    CustomerType.Company,
];

export const organisationStatusMap = {
    [CustomerStatus.NotSpecified]: "All",
    [CustomerStatus.Active]: "Active",
    [CustomerStatus.Prospect]: "Prospect",
    [CustomerStatus.Inactive]: "Inactive",
};

export const RoleTypeMap = {
    [RoleType.NotSpecified]: "All",
    [RoleType.IndividualAccountHolder]: "Individual",
    [RoleType.JointAccountHolder]: "Joint",
    [RoleType.Trustee]: "Trustee",
    [RoleType.Beneficiary]: "Beneficiary",
    [RoleType.Settlor]: "Settlor",
};

export const accountStatusMap = {
    [AccountStatus.Active]: "Wrap: Active",
    [AccountStatus.PendingTC]: "Wrap: Pending Terms & Conditions",
    [AccountStatus.PendingCompliance]: "Wrap: Pending Compliance Check",
    [AccountStatus.Suspended]: "Wrap: Suspended",
    [AccountStatus.Deceased]: "Wrap: Deceased",
    [AccountStatus.DeceasedClosed]: "Wrap: Deceased-Closed",
    [AccountStatus.Closing]: "Wrap: Closing",
    [AccountStatus.Closed]: "Wrap: Closed",
    [AccountStatus.RecordOnly]: "Non-Wrap: Record Only",
    [AccountStatus.Potential]: "Non-Wrap: Potential",
    [AccountStatus.Introductory]: "Non-Wrap: Introductor Pack",
    [AccountStatus.Targeted]: "Non-Wrap: Targeted",
    [AccountStatus.InProgress]: "Non-Wrap: In Progress",
    [AccountStatus.Submitted]: "Non-Wrap: Submitted",
    [AccountStatus.Rejected]: "Non-Wrap: Rejected",
    [AccountStatus.InActive]: "Non-Wrap: Inactive",
};

export const accountStatusMapSorted = {
    0: [AccountStatus.Active],
    1: [AccountStatus.PendingTC],
    2: [AccountStatus.PendingCompliance],
    3: [AccountStatus.Suspended],
    4: [AccountStatus.Deceased],
    5: [AccountStatus.DeceasedClosed],
    6: [AccountStatus.Closing],
    7: [AccountStatus.Closed],
    8: [AccountStatus.RecordOnly],
    9: [AccountStatus.Potential],
    10: [AccountStatus.Introductory],
    11: [AccountStatus.Targeted],
    12: [AccountStatus.InProgress],
    13: [AccountStatus.Submitted],
    14: [AccountStatus.Rejected],
    15: [AccountStatus.InActive],
};

export const organisationTypeMap = {
    [CustomerType.NotSpecified]: "All",
    [CustomerType.CorporateTrust]: "Corporate trust",
    [CustomerType.Trust]: "Trust",
    [CustomerType.Company]: "Company",
};

export const ALL = 98;
export const ALL_WRAP = 99;
export const ALL_NON_WRAP = 100;

export const wrapStatuses = [
    AccountStatus.Active,
    AccountStatus.PendingTC,
    AccountStatus.PendingCompliance,
    AccountStatus.Suspended,
    AccountStatus.Deceased,
    AccountStatus.DeceasedClosed,
    AccountStatus.Closing,
    AccountStatus.Closed,
];

export const nonWrapStatuses = [
    AccountStatus.RecordOnly,
    AccountStatus.Potential,
    AccountStatus.Introductory,
    AccountStatus.Targeted,
    AccountStatus.Submitted,
    AccountStatus.Rejected,
];

export const individualClientStatusSorted = [
    CustomerStatus.NotSpecified,
    CustomerStatus.Active,
    CustomerStatus.Prospect,
    CustomerStatus.Deceased
];

export const organisationStatusMapSorted = [
    CustomerStatus.NotSpecified,
    CustomerStatus.Active,
    CustomerStatus.Prospect,
    CustomerStatus.Inactive,
];

export const getStatus = (status) => {
    switch (status) {
        case ALL:
            return wrapStatuses.concat(nonWrapStatuses);
        case ALL_WRAP:
            return wrapStatuses;
        case ALL_NON_WRAP:
            return nonWrapStatuses;
        case null:
            return null;
        default:
            return [status];
    }
};

export const clientSearchCoachmarkerConfig: ICoachMarkerPageConfig = {
    coachMarkerSetType: CoachMarkerSetType.FnzOneClientSearch,
    steps: [
        {
            title: "Search categories",
            stepPosition: CoachMarkerStepPosition.Bottom,
            positionTop: 63,
            positionLeft: 0,
            stepKey: "client-search-criteria",
            description: (
                <>
                    You can now easily and quickly search by different criteria across client, consolidated or
                    organisation account level categories.
                </>
            ),
        },
        {
            title: "Advanced query",
            stepPosition: CoachMarkerStepPosition.Bottom,
            stepKey: "client-search-advanced",
            positionLeft: 320,
            positionTop: 63,
            description: (
                <>
                    Advanced query allows you to further segment your search criteria by Wrapper, Mandate, Regular
                    payments or Regular withdrawals.
                </>
            ),
        },
    ],
};

export const AccountNumberMinLengthValidationErrorMessage =
    "Please enter a minimum of 3 characters (not including spaces) to trigger results";

    